module.exports = __webpack_public_path__ + "img/rod_logo.ad3a93f5.png";